import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, switchMap } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Role } from '../../models/role';

@Injectable({
  providedIn: 'root'
})
export class AuthRoleService {
  private userRolesByControlSystem: Map<string, Role[]> = new Map();
  private rolesSubject: BehaviorSubject<Map<string, Role[]>> = new BehaviorSubject<Map<string, Role[]>>(this.userRolesByControlSystem);
  private currentControlSystemId: string | null = null;

  constructor(private http: HttpClient) { }

  // Llamada a la API para obtener roles de un controlSystem
  private fetchRolesFromApi(controlSystemId: string): Observable<Role[]> {
    return this.http.get<Role[]>(`${environment.apiUrl}/api/ControlSystems/${controlSystemId}/GetRoles`).pipe(
      catchError(err => {
        console.error('Error:', err);
        return [];
      })
    );
  }

  // Establecer roles por controlSystem
  private setRoles(controlSystemId: string, roles: Role[]) {
    this.userRolesByControlSystem.set(controlSystemId, roles);
    this.rolesSubject.next(this.userRolesByControlSystem); // Emitir los nuevos roles
  }

  // Obtener roles de un controlSystem
  getRoles(controlSystemId: string): Role[] {
    return this.userRolesByControlSystem.get(controlSystemId) || [];
  }

  // Cargar roles desde la API
  loadRoles(controlSystemId: string): Observable<void> {
    this.currentControlSystemId = controlSystemId;

    if (this.userRolesByControlSystem.has(controlSystemId)) {
      return new Observable(observer => {
        observer.next();
        observer.complete();
      });
    }

    return this.fetchRolesFromApi(controlSystemId).pipe(
      switchMap(roles => {
        this.setRoles(controlSystemId, roles);
        return new Observable<void>(observer => {
          observer.next();
          observer.complete();
        });
      })
    );
  }

  // Obtener un observable de roles para ser suscrito
  getRolesObservable(): Observable<Map<string, Role[]>> {
    return this.rolesSubject.asObservable();
  }
  hasAnyRole(allowedRoles: string[]): boolean {
    if (!this.currentControlSystemId) return false;
  
    const roles = this.userRolesByControlSystem.get(this.currentControlSystemId) || [];
    return roles.some(role => allowedRoles.includes(role.roleName));
  }
}
